export default "__VITE_ASSET__93593d78__"